import { QuirkCommunity } from 'model';

export function searchCommunities(search: string, communties: QuirkCommunity[]): QuirkCommunity[] {
	return communties.filter(({ name, searchTerms }) => {
		return (
			name.toLocaleLowerCase().startsWith(search.toLocaleLowerCase()) ||
			name.toLocaleLowerCase() === search.toLowerCase() ||
			searchTerms.includes(search.toLocaleLowerCase())
		);
	});
}
